import React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { AddButton } from 'themes/views/security'
import MappedProperty from './MappedProperty'
// types
import { IField, IInjuryMasterIncidentProperty, IRiskTemplate } from 'types/graphql'
// utils
import { toPropertyOption } from './utils'
// views
import { Mapping } from './views'

interface Props {
  properties: IInjuryMasterIncidentProperty[]
  templateFields: IField[]
  parentTemplates: IRiskTemplate[]
}

const MappedProperties: React.FC<Props & WrappedFieldArrayProps<any>> = ({
  fields,
  properties,
  templateFields,
  parentTemplates
}) => {
  const addRow = () => fields.push({})

  // Injury Master can't create an incident without its required properties (Person involved, Cost
  // centre), so they are mapped up front, ahead of the rest, as soon as the catalog has loaded.
  React.useEffect(() => {
    const mapped = (fields.getAll() ?? []).map((mapping) => mapping?.property?.value)

    properties
      .filter(({ property, requiredOnCreate }) => requiredOnCreate && !mapped.includes(property))
      .forEach((property, index) => fields.insert(index, { property: toPropertyOption(property) }))
  }, [properties])

  return (
    <div>
      {fields.map((name, index) => (
        <Mapping key={name}>
          <MappedProperty
            name={name}
            arrayName={fields.name}
            properties={properties}
            templateFields={templateFields}
            parentTemplates={parentTemplates}
            removeRow={() => fields.remove(index)}
          />
        </Mapping>
      ))}
      <AddButton data-testid='injury-master-mapped-property-add' onClick={addRow}>
        + add property
      </AddButton>
    </div>
  )
}

export default MappedProperties
